module.exports = __webpack_public_path__ + "static/media/19_1.0a12cc53.png";